import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import { WarehouseService } from 'src/app/core/services/warehouse.service';
import { OrderService } from 'src/app/orders/services/order.service';
import { DimensionsUnitsEnum } from 'src/app/core/enums/dimensions-units.enum';
import convertDimensions from 'src/app/core/helpers/dimensions-weight';
import { WeightUnitsEnum } from '../../../core/enums/weight-units.enum';
import convertWeight from '../../../core/helpers/convert-weight';
import { ShippingMethodEnum } from '../../../orders/models/shipping-method.enum';
import { PackageModel } from '../../models/package.model';

@Component({
  selector: 'app-create-package-size-modal',
  templateUrl: './create-package-size-modal.component.html',
})
export class CreatePackageSizeModalComponent implements OnInit {
  @Output() onApprove = new EventEmitter<PackageModel>();

  shippingMethod: ShippingMethodEnum[] = [];

  form: FormGroup = this.fb.group({
    name: [null, Validators.required],
    width: [null, Validators.required],
    length: [null, Validators.required],
    height: [null, Validators.required],
    maxWeight: [null, Validators.required],
    packageWeight: [null, Validators.required],
    isDefault: [0, Validators.required],
    shippingMethod: ['pallets', Validators.required],
  });

  constructor(
    public dialogRef: MatDialogRef<CreatePackageSizeModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: PackageModel,
    private orderService: OrderService,
    private warehouseService: WarehouseService,
  ) { }

  ngOnInit() {
    this.orderService
      .getShippingMethods(this.warehouseService.warehouseId)
      .pipe(tap(shippingMethod => (this.shippingMethod = shippingMethod)))
      .subscribe();

    if (this.data) {
      this.form.patchValue(this.data);
      this.form.patchValue({
        maxWeight: convertWeight(this.data.maxWeight, WeightUnitsEnum.G, WeightUnitsEnum.KG),
        packageWeight: convertWeight(this.data.packageWeight, WeightUnitsEnum.G, WeightUnitsEnum.KG),
        width: convertDimensions(this.data.width, DimensionsUnitsEnum.MM, DimensionsUnitsEnum.CM),
        length: convertDimensions(this.data.length, DimensionsUnitsEnum.MM, DimensionsUnitsEnum.CM),
        height: convertDimensions(this.data.height, DimensionsUnitsEnum.MM, DimensionsUnitsEnum.CM),
      });
      this.form.controls.shippingMethod.disable();
      this.form.controls.shippingMethod.setValue(this.data.shippingMethod);
    }
  }

  approve(): void {
    if (this.form.valid) {
      const payload: PackageModel = {
        ...this.form.value,
        maxWeight: convertWeight(this.form.value.maxWeight, WeightUnitsEnum.KG, WeightUnitsEnum.G),
        packageWeight: convertWeight(this.form.value.packageWeight, WeightUnitsEnum.KG, WeightUnitsEnum.G),
        width: convertDimensions(this.form.value.width, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
        length: convertDimensions(this.form.value.length, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
        height: convertDimensions(this.form.value.height, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
      };

      this.onApprove.emit(payload);
      this.dialogRef.close();
    }
  }

  reject(): void {
    this.dialogRef.close();
  }
}
